import React from 'react';
import logoMark from '../../Images/logo/logo.png';
import logoBanner from '../../Images/logo/banner.png';
import logoBannerDark from '../../Images/logo/banner-dark.png';
import styles from './brandLogo.module.css';

/** Circular B4 mark. */
export function BrandMark({ className, title }) {
  return (
    <img
      className={className}
      src={logoMark}
      alt={title || ''}
      width="64"
      height="64"
      draggable="false"
    />
  );
}

/**
 * @param {"mark" | "lockup" | "banner"} variant
 * @param {"onDark" | "onLight"} tone
 */
const BrandLogo = ({ variant = 'lockup', tone = 'onDark', wordmark = 'B4BARBER', className }) => {
  if (variant === 'banner') {
    const bannerSrc = tone === 'onDark' ? logoBannerDark || logoBanner : logoBanner;
    return (
      <img
        className={`${styles.banner} ${
          tone === 'onLight' ? styles.bannerOnLight : styles.bannerOnDark
        } ${className || ''}`.trim()}
        src={bannerSrc}
        alt={wordmark}
        draggable="false"
      />
    );
  }

  return (
    <span
      className={`${styles.brand} ${
        tone === 'onLight' ? styles.onLight : styles.onDark
      } ${className || ''}`.trim()}
    >
      <BrandMark className={styles.mark} title={variant === 'mark' ? wordmark : ''} />
      {variant === 'lockup' ? <span className={styles.word}>{wordmark}</span> : null}
    </span>
  );
};

export default BrandLogo;
